import { render, staticRenderFns } from "./RequesterTBDetails.vue?vue&type=template&id=75cdcc10&"
import script from "./RequesterTBDetails.vue?vue&type=script&lang=js&"
export * from "./RequesterTBDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75cdcc10')) {
      api.createRecord('75cdcc10', component.options)
    } else {
      api.reload('75cdcc10', component.options)
    }
    module.hot.accept("./RequesterTBDetails.vue?vue&type=template&id=75cdcc10&", function () {
      api.rerender('75cdcc10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/toolbox/RequesterTBDetails.vue"
export default component.exports